import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';


function KnobTypeRadio(props) {
    return ( 
        <div className={`bg-gray-100 h-32 pt-4 pl-3 mb-5 origin-left shadow-xl text-left
                        ${props.open ? 'w-36' : 'w-0'} duration-300`}>
            <div className={`${!props.open ? 'scale-0' : 'transition delay-150'}`}>
            <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">Knob Type</FormLabel>
            <RadioGroup
                // row
                aria-labelledby="demo-row-radio-buttons-group-label"
                // name="row-radio-buttons-group"
                defaultValue={"dimension"}
                onChange={props.onChange}
            >
                <FormControlLabel value="dimension" control={<Radio />} label="Dimension" checked={props.value==="dimension"} />
                <FormControlLabel value="attribute" control={<Radio />} label="Attribute" checked={props.value==="attribute"} />
            </RadioGroup>
            </FormControl>
            </div>
        </div>
     );
}

export default KnobTypeRadio;